import * as React from "react";
import { forwardRef } from "react";
const SvgLegendCircle = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 8, height: 8, viewBox: "0 0 8 8", fill: "none", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 3, stroke: "currentColor", strokeWidth: 2 }));
const ForwardRef = forwardRef(SvgLegendCircle);
export { ForwardRef as ReactComponent };
